module.exports = __webpack_public_path__ + "img/resized-APP-0003-1.81641d29.png";